import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withNavigate from './withNavigate';

const Logout = (props) => {

  useEffect(() => {
    props.logOut();
    localStorage.removeItem('userDetailsAdmin');
    sessionStorage.clear();
    props.navigate('/signin', { replace: true });
  }, []);

  return <div></div>;
};

Logout.contextTypes = {
  router: PropTypes.object
};

export default withNavigate(Logout);
